import { FormattedMessage } from "react-intl";

import { DEFAULT_VALUES, useLocalizedHref } from "@/libraries/web-framework";

const IdentityAccessManagement = () => {
    const localizedHref = useLocalizedHref("/software/access");

    return (
        <div>
            <p>
                <FormattedMessage
                    id="ConfluencePricingPageTeam24.features.IdentityAccessManagement.content.body.v2"
                    defaultMessage="Get support for multiple identity providers (IdPs) within your central admin console, plus SCIM, enforce SSO, and more with <a>Atlassian Guard Standard</a> included."
                    values={{
                        ...DEFAULT_VALUES,
                        a: (chunks) => (
                            <a
                                data-event="clicked"
                                data-event-component="linkButton"
                                data-product-key="confluence"
                                data-label-english="Atlassian Guard"
                                data-track-event="ConfluencePricingPageTeam24.identityAccessManagement.learnMore"
                                data-event-container="ConfluencePriceFinderTeam24"
                                href={localizedHref}
                            >
                                {chunks}
                            </a>
                        )
                    }}
                />
            </p>
        </div>
    );
};
export default IdentityAccessManagement;
